import { all, takeEvery, put, call } from 'redux-saga/effects'
import { getFormasPago } from 'services/logisticaPedido'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_FORMAS_PAGO() {
  try {
    const formaPagoData = yield call(getFormasPago)
    if (formaPagoData.ok) {
      yield put({
        type: actions.FORMAS_PAGO_LOAD_SUCCEEDED,
        payload: formaPagoData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar formas de pago')
      put({
        type: actions.FORMAS_PAGO_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.FORMAS_PAGO_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.FORMAS_PAGO_LOAD_REQUESTED, GET_FORMAS_PAGO)])
}
